import $ from 'jquery';

import castingDesc from './casting';
import episodeDetail from './episode';
import { drawRatingChart, ratings, getRatingsData } from './rating';
import { videoClip, videoCol, beforeClip } from './clip';


const $coll = $('#tvpColl');
const $tab = $coll.find('.tab_nav');
const $tabList = $tab.find('.list_tab');

const $programCont = $coll.find('#tv_program');
const $episodeCont = $coll.find('#tv_episode');
const $scheduleCont = $coll.find('#tv_schedule');
const $ratingCont = $coll.find('#tv_rating');




function schedule(ctx, nextCount, prevCount) {
  const $btn = ctx.find('.tbl_head a');
  const $tblHead = ctx.find('.tbl_head .tit_col');
  const $tblBody = ctx.find('.tbl_body tr');

  $btn.on('click', function () {
    if ($(this).hasClass('btn_next')) {
      $(this).addClass('btn_off');
      $(this).siblings('a').removeClass('btn_off');
      $tblHead.each(function (index, item) {
        nextSchedule(index, item);
      });
      $tblBody.each(function (index, item) {
        let $tblBodyTd = $(item).find('td');
        $tblBodyTd.each(function (index, item) {
          nextSchedule(index, item);
        });
      });
    } else {
      $(this).addClass('btn_off');
      $(this).siblings('a').removeClass('btn_off');
      $tblHead.each(function (index, item) {
        prevSchedule(index, item);
      });
      $tblBody.each(function (index, item) {
        let $tblBodyTd = $(item).find('td');
        $tblBodyTd.each(function (index, item) {
          prevSchedule(index, item);
        });
      });
    }
  });
  function nextSchedule(index, item) {
    index < nextCount ? $(item).addClass('hide') : $(item).removeClass('hide');
  }
  function prevSchedule(index, item) {
    index > prevCount ? $(item).addClass('hide') : $(item).removeClass('hide');
  }
}
function descFold(ctx) {
  const $ctx = ctx;
  const $desc = $ctx.find('.episode_desc');
  const $btn = $ctx.find('.more_comm');
  const $txt = $btn.find('.inner');
  $btn.on('click', function () {
    $desc.toggleClass('open');
    $desc.hasClass('open') ? $txt.text('접기') : $txt.text('더보기');
  });
}


function characterPager() {
  const $ctx = $coll.find('#listCharacter');
  const $pagerNav = $ctx.find('.paging_nav');
  const $contList = $ctx.find('.col_size5 li');
  const pager = new SF.pager({
    navigation: $pagerNav,
    list: $contList,
    viewCount: 5,
    isInfinite: false
  });
}

function btnMore(ctx) {
  const $btn = ctx.find('.f_nb');
  $btn.on('click', function () {
    const contId = $(this).data('id');
    $tabList.children('li[data-tab="tv_' + contId + '"]').trigger('click');
  });
}



const tabs = new SF.tab({
  tab: $('.tab_nav'),
  cont: $('#tabCont'),
  callback: function () {

    const $onTab = $tab.find('.on');
    const tabId = $onTab.data('tab');

    sessionStorage.setItem('state', tabId);

    if (window.KTP) {
      KTP.Player.pauseAll();
    }

    if ($onTab.data('tab') === 'tv_rating') {
      C.TVP.data.tabInfo = 'rating';
      drawRatingChart($ratingCont, 'ratingGraph');
    }
  }
});

function historySession() {
  const windowState = SF.history.isHistoryBack;
  const tabState = sessionStorage.state;

  windowState ? $tabList.find('li[data-tab=' + tabState + ']').trigger('click') : '';
}

SF.loadModule('kakaotv', function (status, module) {
  if (status === 'success') {
    videoClip($coll);
    videoCol($programCont);
    beforeClip($programCont);
  }
  episodeDetail($episodeCont);
});

getRatingsData().done((response) => {
  try {
    ratings($programCont, response);
    ratings($ratingCont, response);
  } catch (e) {
    console.log(e);
  }
});

castingDesc($coll);
drawRatingChart($ratingCont, 'ratingGraph');
descFold($episodeCont);
schedule($scheduleCont, 3, 3);
schedule($episodeCont, 2, 3);
characterPager();
btnMore($programCont);
historySession();



/** WEBPACK FOOTER **
 ** ./src/TVP/index.js
 **/